module.exports = __webpack_public_path__ + "assets/horizontal-dots.b0725318.svg";